import {
  SET_SWATCH_COLOR_NAME,
  SET_SELECTED_PRODUCTS_DATA,
  SET_INIT_SELECTED_PRODUCTS_DATA,
  SET_INVENTORY_DATA,
  SET_PROJECTION_DATA,
  SET_INVENTORY_STATUS,
} from "./actions/actionTypes"

export const initialState = {
  bundlePdp: {},
  selectedProducts: [],
}

/**
 * Reducer function to handle state updates based on action types.
 *
 * @param {Object} state - The current state of the application.
 * @param {Object} action - The action dispatched to the reducer.
 * @param {string} action.type - The type of the action.
 * @param {any} action.payload - The payload of the action.
 * @return {Object} The updated state.
 */
export default function reducer(state = initialState, action) {
  const { type, payload } = action

  let updatedState
  if (type === SET_SWATCH_COLOR_NAME) {
    updatedState = { ...state, swatchName: payload }
  } else if (type === SET_SELECTED_PRODUCTS_DATA) {
    const selectedItem = state.selectedProducts || []
    const selectedProduct = selectedItem.find(item => item.id === payload.id)
    if (selectedProduct) {
      selectedItem[payload.id] = payload
    } else {
      selectedItem.push(payload)
    }
    updatedState = { ...state, selectedProducts: selectedItem }
  } else if (type === SET_INIT_SELECTED_PRODUCTS_DATA) {
    updatedState = { ...state, selectedProducts: payload }
  } else if (type === SET_INVENTORY_DATA) {
    updatedState = { ...state, inventory: payload }
  } else if (type === SET_INVENTORY_STATUS) {
    updatedState = { ...state, inventoryStatus: payload }
  } else if (type === SET_PROJECTION_DATA) {
    updatedState = { ...state, projectionData: payload }
  } else {
    updatedState = state
  }

  return updatedState
}
